module.exports = {
	"notification.message": "Wix.com utilise les cookies afin de vous proposer une expérience optimale.",
	"notification.got.it": "OK",
	"notification.more.info": "En lire plus"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_fr.json
// module id = 41
// module chunks = 0